import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import useReactRouter from 'use-react-router';
import qs from 'query-string';
import { pipe, pick, pickBy, complement, isNil } from 'ramda';
import { mergePrequalOffer, PrequalOffer } from 'state/prequalOffer';
import canUseDOM from 'utils/canUseDOM';

type QueryType = { [key in string]: string };

const renameKey = (obj: QueryType, oldKey: string, newKey: string) => {
  delete Object.assign(obj, {
    [newKey]: obj[oldKey],
  })[oldKey];
};

const useLoadInitialPrequalOfferData = (initialDataKeys: string[]): void => {
  const dispatch = useDispatch();
  const { location } = useReactRouter();

  const query = useMemo(() => {
    return qs.parse(location.search, {
      parseBooleans: true,
    });
  }, [location]);

  if (canUseDOM || initialDataKeys.length === 0) {
    // We don't load the query params in browser, so this is always successful.
    return;
  }
  const details = pipe(
    pick(initialDataKeys),
    pickBy((v, _) => complement(isNil)(v) && v),
  )(query) as QueryType;

  renameKey(details, 'prequalCreditLimit', 'creditLimit');

  // Done parsing, so now the value can be considered a PrequalOffer
  const prefill = details as Partial<PrequalOffer>;

  dispatch(mergePrequalOffer(prefill));
};

export default useLoadInitialPrequalOfferData;
